var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"map"}}),_c('ToolBar',{attrs:{"selected":_vm.selected},on:{"change":_vm.onSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }